import { render } from "./transferTable.vue?vue&type=template&id=0ab8833a"
import script from "./transferTable.vue?vue&type=script&lang=js"
export * from "./transferTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__